import React from "react";
import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Divider,
  useTheme,
} from "@mui/material";

const InfrastructureCardSkeleton = () => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        width: "100%",
        border: `1px solid ${theme.customColors.border.main}`,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
        <Box>
          {/* Logo and Title Skeleton */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2.5,
              mb: 2,
            }}
          >
            <Skeleton
              variant="rectangular"
              width={56}
              height={56}
              sx={{ borderRadius: "10px" }}
            />
            <Skeleton variant="text" width={120} height={32} />
          </Box>

          {/* Divider */}
          <Divider sx={{ my: 2, borderColor: theme.customColors.border.subtle }} />

          {/* Labels Skeleton */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1,
            }}
          >
            <Skeleton variant="text" width={140} height={20} />
            <Skeleton variant="text" width={100} height={20} />
          </Box>

          {/* Values Skeleton */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Skeleton variant="rectangular" width={300} height={40} sx={{ borderRadius: 1 }} />
            <Skeleton variant="text" width={60} height={28} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default InfrastructureCardSkeleton;

